import { useCallback, useState, useMemo } from 'react'
import GroupConditionType from '../types/GroupCondition'
import { transformGroupConditionToPayload } from '../util/groupConditionTransform'

function hasGroupConditionChanged(lastSavedGroupCondition: any, currentGroupCondition: any) {
    return JSON.stringify(lastSavedGroupCondition) !== JSON.stringify(currentGroupCondition)
}

function saveDraftPromise(newGroupConditions: any, offerService: any) {
    return new Promise(function(resolve, reject) {
        offerService.offerFormData.status = 'DRAFT';
        try {
            offerService.saveConditionData(transformGroupConditionToPayload(newGroupConditions))
            offerService.saveOfferFormAsDraft()
                .then((response: any) => {
                    if (response && response.msgInfo && response.msgInfo !== 200) {
                        reject(false)
                    } else {
                        resolve(true)
                    }
                })
                .catch((err: any) => {
                    console.error(err)
                    reject(false)
                })
            } catch(err) {
                console.error(err)
                reject(false)
            }
    })
}

interface UseSaveDraftReturn {
    error: string
    lastSaved: GroupConditionType[]
    loading: boolean
    saveAsDraft: (groupConditions: GroupConditionType[]) => Promise<any>
    groupConditionsHaveChanged: (groupConditions: GroupConditionType[]) => boolean
}
export default function useSaveDraft(initialGroupConditions: GroupConditionType[], offerService: any, errorAriaLabel: string): UseSaveDraftReturn {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [lastSaved, setLastSaved] = useState(() => JSON.parse(JSON.stringify(initialGroupConditions)))

    const saveDraft = useCallback(async (groupConditions: GroupConditionType[]) => {
        setError('')
        setLoading(true)
        try {
            const wasSuccess = await saveDraftPromise(groupConditions, offerService)

            if (!wasSuccess) {
                setLoading(false)
                setError(errorAriaLabel)
                return false
            }

            setLoading(false)
            setError('')
            return true
        } catch(err) {
            console.error(err)
            setError(errorAriaLabel)
            setLoading(false)
            return false
        }
    }, [offerService])

    const groupConditionsHaveChanged = useCallback((groupConditions: GroupConditionType[]) => {
        return hasGroupConditionChanged(lastSaved, groupConditions)
    }, [lastSaved])

    return useMemo(() => ({
        error,
        lastSaved,
        loading,
        saveAsDraft: saveDraft,
        groupConditionsHaveChanged,
    }), [
        error,
        lastSaved,
        loading,
        saveDraft,
        groupConditionsHaveChanged,
    ])
}